module.exports = __webpack_public_path__ + "img/20200625_085014.7410b166.jpg";